import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
import QIcon from "../icon/QIcon.js";
import ListenersMixin from "../../mixins/listeners.js";
import { slot, uniqueSlot } from "../../utils/private/slot.js";
export default Vue.extend({
  name: 'QTimelineEntry',
  inject: {
    __timeline: {
      default: function _default() {
        console.error('QTimelineEntry needs to be child of QTimeline');
      }
    }
  },
  mixins: [ListenersMixin],
  props: {
    heading: Boolean,
    tag: {
      type: String,
      default: 'h3'
    },
    side: {
      type: String,
      default: 'right',
      validator: function validator(v) {
        return ['left', 'right'].includes(v);
      }
    },
    icon: String,
    avatar: String,
    color: String,
    title: String,
    subtitle: String,
    body: String
  },
  computed: {
    colorClass: function colorClass() {
      return "text-".concat(this.color || this.__timeline.color);
    },
    classes: function classes() {
      return "q-timeline__entry--".concat(this.side) + (this.icon !== void 0 || this.avatar !== void 0 ? ' q-timeline__entry--icon' : '');
    },
    reverse: function reverse() {
      return this.__timeline.layout === 'comfortable' && this.__timeline.side === 'left';
    }
  },
  render: function render(h) {
    var child = uniqueSlot(this, 'default', []);
    if (this.body !== void 0) {
      child.unshift(this.body);
    }
    if (this.heading === true) {
      var _content = [h('div'), h('div'), h(this.tag, {
        staticClass: 'q-timeline__heading-title'
      }, child)];
      return h('div', {
        staticClass: 'q-timeline__heading',
        on: _objectSpread({}, this.qListeners)
      }, this.reverse === true ? _content.reverse() : _content);
    }
    var dot;
    if (this.icon !== void 0) {
      dot = [h(QIcon, {
        staticClass: 'row items-center justify-center',
        props: {
          name: this.icon
        }
      })];
    } else if (this.avatar !== void 0) {
      dot = [h('img', {
        staticClass: 'q-timeline__dot-img',
        domProps: {
          src: this.avatar
        }
      })];
    }
    var content = [h('div', {
      staticClass: 'q-timeline__subtitle'
    }, [h('span', slot(this, 'subtitle', [this.subtitle]))]), h('div', {
      staticClass: 'q-timeline__dot',
      class: this.colorClass
    }, dot), h('div', {
      staticClass: 'q-timeline__content'
    }, [h('h6', {
      staticClass: 'q-timeline__title'
    }, slot(this, 'title', [this.title]))].concat(child))];
    return h('li', {
      staticClass: 'q-timeline__entry',
      class: this.classes,
      on: _objectSpread({}, this.qListeners)
    }, this.reverse === true ? content.reverse() : content);
  }
});